module.exports = {
  DOCX_REPORT_VIEWPORT_WIDTH: 722,
  DOCX_REPORT_VIEWPORT_HEIGHT: 475,
  getCommaSeparatedString: function getCommaSeparatedString(stringArr) {
    if (stringArr == null) {
      return '';
    }

    var string = stringArr.reduce(function (total, str) {
      return str != null && str !== '' ? total + str + ', ' : total;
    }, '');
    return string !== '' ? string.substring(0, string.length - 2) : '';
  },
  joinTasksWithRanges: function joinTasksWithRanges(tasks) {
    if (tasks == null || tasks.length === 0) {
      return '';
    }

    var lastActiveIndex;
    return tasks.reduce(function (result, task, index) {
      if (!task.isActive) {
        return result;
      }

      if (lastActiveIndex == null) {
        lastActiveIndex = index;
        return '';
      }

      if (index - lastActiveIndex === 1) {
        if (!result.endsWith('-')) {
          result += lastActiveIndex + 1 + '-';
        }
      } else {
        result += lastActiveIndex + 1 + ', ';
      }

      lastActiveIndex = index;
      return result;
    }, '') + (lastActiveIndex != null ? lastActiveIndex + 1 : '');
  }
};